import { Application, StatusSummary } from "./JobApplicationsModel";

// JobApplicationsState.ts
export interface JobApplicationsState {
  applications: Application[];
  filteredApplications: Application[];
  statusSummary: StatusSummary;
  statusFilter: string;
  selectedApplication: Application | null;
  showDetailsModal: boolean;
  loading: boolean;
  error: string | null;
  toast: { message: string; type: 'success' | 'error' } | null;
  // Backend pagination state
  currentPage: number;
  totalPages: number;
  totalApplications: number;
  applicationsPerPage: number;
  hasMore: boolean;
  viewMode: 'grid' | 'list';
}

export const initialJobApplicationsState: JobApplicationsState = {
  applications: [],
  filteredApplications: [],
  statusSummary: {},
  statusFilter: '',
  selectedApplication: null,
  showDetailsModal: false,
  loading: true,
  error: null,
  toast: null,
  // Initialize pagination
  currentPage: 1,
  totalPages: 1,
  totalApplications: 0,
  applicationsPerPage: 8,
  hasMore: false,
  viewMode: 'grid',
};